import Image from "next/image";
import React from "react";

import { Card } from "@/components/ui";
import { cn } from "@/utils/cn";
import { ObjectDetailActions } from "@/widgets/ObjectDetail/Actions";

interface Manager {
  photo: string;
  name: string;
  role: string;
}

interface SalesDepartmentProps {
  className?: string;
  photo: string;
  name: string;
  role: string;
}

export const SalesDepartment: React.FC<SalesDepartmentProps> = ({
  className,
  photo,
  name,
  role,
}) => {
  if (!name || !photo || !role) {
    return null;
  }

  return (
    <Card className={cn("flex flex-col gap-8", className)}>
      <div className="flex items-center gap-4">
        <div className="relative w-40 h-40 rounded-sm overflow-hidden bg-gray-200">
          <Image
            src={photo}
            alt={name}
            fill
            className="object-cover"
          />
        </div>
        <div>
          <p className="font-semibold text-lg">{name}</p>
          <p className="text-sm text-gray-500">{role}</p>
        </div>
      </div>
      <ObjectDetailActions />
    </Card>
  );
};
